import { render, staticRenderFns } from "./ApplicationForReviewRspToLeaveRefusedPg.vue?vue&type=template&id=3b4ed390&scoped=true"
import script from "./ApplicationForReviewRspToLeaveRefusedPg.vue?vue&type=script&lang=ts"
export * from "./ApplicationForReviewRspToLeaveRefusedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ed390",
  null
  
)

export default component.exports